import { KYDAdminEventSummary } from "./KYDEvent";
import { Price } from "./KYDTicket";
import { IKYDUser } from "./KYDUser";
import { KYDContact, KYDSegment } from "./KYDCampaign";

export enum AlgoliaIndexType {
  EVENTS = "EVENTS",
  ORGANIZATIONS = "ORGANIZATIONS",
  ATTENDEES = "ATTENDEES",
  CONTACTS = "CONTACTS",
  SEGMENTS = "SEGMENTS",
  AD_CAMPAIGNS = "AD_CAMPAIGNS",
}

export type AlgoliaSortOrder = "ascending" | "descending";

export interface AlgoliaSegmentObject extends KYDSegment {
  objectID: string;
  created_at_unix: number;
  _tags?: string[];
}

export interface AlgoliaEventObject extends KYDAdminEventSummary {
  objectID: string;
  start_at_unix: number;
  _tags?: string[];
}

export interface AlgoliaContactObject extends KYDContact {
  objectID: string;
  last_active_at_unix: number;
  _tags?: string[];
}

export interface TicketTransaction {
  payment_id?: string;
  number_of_tickets?: number;
  ticket_ids: string[];
  display_total?: string;
  created_at: string;
}

export interface AlgoliaAttendeeObject extends IKYDUser {
  objectID: string;
  tickets_count: number;
  phone_number_parts: string[];
  phone_number_display: string;
  on_guestlist: boolean;
  notes?: string;
  updated_at: string;
  _tags?: string[];
  kyd_tags?: string[];
  ticket_type_ids: string[];
}

export interface AlgoliaTicket {
  id: string;
  ticket_type_id: string;
  attended_at?: string;
  purchased_at?: string;
  sale?: {
    source?: string;
    tender_type?: string;
    created_at?: string;
    total?: Price;
    display_total?: string;
    payment_id?: string;
  };
}

/** Minimal ad campaign record for Algolia search/sort (name, status, dates, metrics). */
export interface AlgoliaAdCampaignObject {
  objectID: string;
  id?: string;
  name: string;
  organization_id: string;
  status?: string;
  image_url?: string;
  created_at?: string;
  updated_at?: string;
  updated_at_unix: number;
  created_at_unix: number;
  /** Earliest linked event start (for sorting by event date). */
  event_start_at?: string;
  event_start_at_unix: number;
  _tags: string[];
  /** Display fields for list UI */
  schedule_start_at?: string;
  schedule_end_at?: string;
  /** Unix timestamp of schedule end (0 if no end). Used to filter active vs past. */
  schedule_end_at_unix?: number;
  display_spend?: string;
  /** Total campaign budget (for "spend / budget" display). */
  display_budget?: string;
  /** Platform purchase value or ticket GMV (for list UI). */
  display_purchase_value?: string;
  display_roas?: string;
  display_tickets?: string;
  display_ctr?: string;
  /** Most important intent summary for list UI (error > warning > info). */
  primary_intent_summary?: string;
  /** All intent summary texts (for "N Optimizations" + hover list). */
  intent_summaries?: string[];
  /** Server-driven performance tier for list dot: HIGH_PERFORMANCE | UNDERPERFORMING | ON_TRACK | TOO_EARLY_TO_TELL. When missing, UI shows gray (legacy). */
  performance_tier?: string;
  /** Display any campaign error in the UI */
  publish_errors?: string[];
}
